import { useState } from "react"
import { formatDateShort } from "./formatters"
import { Button } from "@ui/Button"
import { Input } from "@ui/Input"
import { Popover } from "@ui/Popover"
import CalendarIcon from "../../icons/cisco-momentum/core/calendar-month-regular.svg?react"
import CaretDownIcon from "../../icons/cisco-momentum/core/arrow-down-bold.svg?react"

export default function DateRangePicker({ dateRange, onChange }) {
  const [ open, setOpen ] = useState(false)
  const [ tempFrom, setTempFrom ] = useState("")
  const [ tempTo, setTempTo ] = useState("")

  function handleOpenChange(next) {
    if (next) {
      setTempFrom(dateRange.from.toISOString().split("T")[0])
      setTempTo(dateRange.to.toISOString().split("T")[0])
    }
    setOpen(next)
  }

  function handleApply() {
    const from = new Date(tempFrom + "T00:00:00")
    const to = new Date(tempTo + "T23:59:59")
    onChange({ from, to })
    setOpen(false)
  }

  return (
    <div className="mb-4">
      <Popover.Root open={open} onOpenChange={handleOpenChange}>
        <Popover.Trigger
          render={
            <Button
              variant="secondary"
              leadingIcon={<CalendarIcon className="w-4 h-4" aria-hidden="true" />}
              trailingIcon={<CaretDownIcon className="w-3.5 h-3.5" aria-hidden="true" />}
            >
              {formatDateShort(dateRange.from.toISOString())} - {formatDateShort(dateRange.to.toISOString())}
            </Button>
          }
        />
        <Popover.Content side="bottom" align="start" sideOffset={6} className="w-[280px] p-4">
          <div className="space-y-3">
            <div>
              <label className="text-xs text-webex-gray-600 dark:text-webex-gray-400 mb-1 block">From</label>
              <Input
                type="date"
                value={tempFrom}
                onChange={e => setTempFrom(e.target.value)}
              />
            </div>
            <div>
              <label className="text-xs text-webex-gray-600 dark:text-webex-gray-400 mb-1 block">To</label>
              <Input
                type="date"
                value={tempTo}
                onChange={e => setTempTo(e.target.value)}
              />
            </div>
            <div className="flex items-center gap-2 pt-1">
              <Button variant="primary" onClick={handleApply}>Apply</Button>
              <Button variant="secondary" onClick={() => setOpen(false)}>Cancel</Button>
            </div>
          </div>
        </Popover.Content>
      </Popover.Root>
    </div>
  )
}
